/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetMyReservationInvoicePathParameters } from 'api/actions/get-my-reservation-invoice/get-my-reservation-invoice-path-parameters';
import { GetMyReservationInvoiceResponse } from 'api/actions/get-my-reservation-invoice/get-my-reservation-invoice-response';

type GetMyReservationInvoiceQueryParameters = Record<string, any>;

/**
 * The path of the GetMyReservationInvoice action.
 */
export const getMyReservationInvoiceActionPath = new SweetPath<keyof GetMyReservationInvoicePathParameters>(
  '/reservations/invoices/{invoiceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetMyReservationInvoice actions.
 */
export default function createGetMyReservationInvoiceAction(axios: AxiosInstance) {
  return function getMyReservationInvoiceAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetMyReservationInvoicePathParameters;
    query?: GetMyReservationInvoiceQueryParameters;
  }) {
    const path = getMyReservationInvoiceActionPath.insert(parameters);

    return axios.get<GetMyReservationInvoiceResponse, GetMyReservationInvoiceResponse>(path, {
      params: query,
      headers,
    });
  };
}
